import React, { useState } from "react";
import styles from "./ConfirmationDialog.module.css";

interface ConfirmationDialogProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onDontShowAgain: (checked: boolean) => void;
  isSaving?: boolean;
}

const ConfirmationDialog = ({
  show,
  onCancel,
  onConfirm,
  onDontShowAgain,
  isSaving
}: ConfirmationDialogProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setDontShowAgain(isChecked);
    onDontShowAgain(isChecked);
  };

  if (!show) return null;

  return (
    <div className={styles.dialogOverlay}>
      <div className={styles.dialogContainer}>
        <div className={styles.dialogContent}>
          <h3 className={styles.dialogTitle}>Confirm Action</h3>
          <p className={styles.dialogMessage}>
            <strong>
              Once you click on Proceed, you won't be able to return to this
              question.
            </strong>
          </p>

          <div className={styles.checkboxContainer}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={handleCheckboxChange}
                className={styles.checkbox}
              />
              Don't show this again
            </label>
          </div>

          <div className={styles.dialogActions}>
            <button
              onClick={onCancel}
              className={`${styles.dialogButton} ${styles.cancelButton}`}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={`${styles.dialogButton} ${styles.confirmButton}`}
              disabled={isSaving}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
